import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useApolloClient } from "@apollo/client";
import TextInput from "./TextInput";
const AddressInput = ({ fulfillmentId, label, placeholder, fieldName, addressFields, required, highlighted, }) => {
    const client = useApolloClient();
    const updateField = (ev) => {
        client.cache.modify({
            id: `Fulfillment:${fulfillmentId}`,
            fields: {
                address(currentAddress) {
                    return Object.assign(Object.assign({}, currentAddress), { [fieldName]: ev.target.value });
                }
            }
        });
    };
    const style = highlighted ? { borderColor: "#FF877B" } : {};
    return (_jsxs("div", { children: [_jsxs("label", { className: "my-4 block w-full", htmlFor: fieldName, children: [label, " ", required && _jsx("span", { className: "text-wfRed-600", children: "*" })] }), _jsx(TextInput, { id: fieldName, style: style, placeholder: placeholder, value: addressFields[fieldName], onChange: updateField, required: required, className: "p-2 w-full text-lg font-semibold" })] }));
};
export default AddressInput;
